let timeBack = 10;
const handleF = () => {
  const target = $(".js-qty__adjust");  
  if (target.length > 0) {
    $(target).on("click", () => {
      setTimeout(() => {
          BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html()), false, false);
      }, 1000)
    })
    $(".js-qty__num").on("change", () => {
      setTimeout(() => {
          BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html()), false, false);
      }, 1000)
    })
  }
  else if (timeBack-- > 0){
    setTimeout(handleF, 300);
  }
}
handleF();

if(typeof BSS_B2B != undefined) {
    if(window.location.pathname.includes("/products")) {
        setTimeout(() =>{
          let variantBtn = $(".variant-input input[type='radio']");
          if(variantBtn.length > 1) {
              variantBtn.on("click", ()=>{
                setTimeout(() =>{
                  BSS_B2B.qi.handleSetupQuantity()
                }, 500)
                  
              })
          }
        }, 300)
        
    }
   // fix spam checkout
    setTimeout(() =>{
      function handleButtonClick(e) {
        e.preventDefault();
        const $button = $(this);
        let oldText = $(this).text();
        $button.css({'pointer-events': 'none', 'opacity': '0.6'});
        $button.text("Loading ...");
        setTimeout(() =>{
          $button.css({'pointer-events': 'unset', 'opacity': '1'})
            $button.text(oldText);
        }, 2000);
      }
   
     $(document).on('click dblclick', '#CartDrawer button[type="submit"]', handleButtonClick);
    }, 500)
}
